import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { FORM_BUTTON_TYPES } from '../';
import Button from '../../Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function FormButtons(_ref) {
  var buttonsContainerStyles = _ref.buttonsContainerStyles,
    buttons = _ref.buttons;
  return _jsx(Flex, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, defaultButtonsContainerStyles), buttonsContainerStyles)), {}, {
    children: buttons.map(button => {
      return _createElement(Box, _objectSpread(_objectSpread({}, button.styles), {}, {
        key: button.label
      }), _jsx(Button, _objectSpread(_objectSpread({
        type: button.type,
        "data-testid": button.testid
      }, button.props), {}, {
        onClick: () => {
          if (button.type !== FORM_BUTTON_TYPES.SUBMIT) {
            button.action();
          }
        },
        children: button.label
      })));
    })
  }));
}
var defaultButtonsContainerStyles = {
  direction: 'column',
  justifyContent: 'flex-start',
  marginBottom: 'var(--chakra-space-lg)',
  width: '100%'
};